
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.25,32.73c0-7.84-6.38-14.23-14.23-14.23s-14.23,6.38-14.23,14.23,6.38,14.23,14.23,14.23,14.23-6.38,14.23-14.23ZM47.45,32.74c0,4.65-3.78,8.42-8.43,8.42s-8.42-3.78-8.42-8.42,3.78-8.42,8.42-8.42,8.43,3.78,8.43,8.42Z"}}),_c('path',{attrs:{"d":"M39.04,9.45h-.17c-3.07.01-6.05.62-8.8,1.76l-2.66-5.32-.11-.21c-.76-1.38-2.48-1.91-3.87-1.19-4.59,2.36-8.54,5.86-11.44,10.13-2.96,4.36-4.72,9.43-5.09,14.69-.1,1.59,1.11,2.97,2.7,3.08l6.15.43c.04,4.4,1.29,8.67,3.62,12.38l-2.51,5.02H4.58c-1.6,0-2.91,1.3-2.91,2.91v6.8c0,1.6,1.3,2.9,2.9,2.91h0c1.6,0,2.9-1.31,2.9-2.91v-3.89h11.05s.07,0,.1,0h20.39c12.85,0,23.3-10.45,23.3-23.3s-10.44-23.29-23.29-23.3ZM16.45,27.04l-3.38-.23c.62-3.21,1.87-6.21,3.72-8.94,1.82-2.68,4.09-4.94,6.76-6.73l1.49,2.97c-.89.67-1.75,1.39-2.55,2.19-2.99,3.02-5.03,6.72-6.03,10.74ZM25.3,46.26c.49-.98.39-2.13-.26-3.01-2.24-3.03-3.49-6.76-3.51-10.59.02-9.66,7.88-17.5,17.53-17.5h.04c9.67.02,17.52,7.9,17.5,17.56-.02,9.58-7.76,17.37-17.3,17.5h-15.97s1.98-3.97,1.98-3.97Z"}})])
          )
        }
      }
    